import React, { useEffect, useState } from 'react';
import rideService from 'src/services/rideService';

const UpdatePopup = ({ isOpen, onClose, onSubmit, vehicleId, initialVehicleRate, initialCommissionPercentage }) => {
  // State to manage the input value
  const [ratePerKm, setRatePerKm] = useState(initialVehicleRate);
  const [commissionPercentage, setCommissionPercentage] = useState(initialVehicleRate);
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(()=>{
    setRatePerKm(initialVehicleRate);
    setCommissionPercentage(initialCommissionPercentage);
  },[initialVehicleRate, initialCommissionPercentage])
  // If the popup is not open, don't render anything
  if (!isOpen) {
    return null;
  }

  // Function to handle input value changes
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setRatePerKm(inputValue);
  };
  const handleCommissionChange = (event) => {
    const inputValue = event.target.value;
    setCommissionPercentage(inputValue);
  };

  // Function to handle form submission
  const handleSubmit = () => {
    onSubmit(updateRidePerKm()); // Call the onSubmit prop with the updated value
    // onClose(); // Close the popup
  };

 const updateRidePerKm= async()=>{
  if(ratePerKm!=null && ratePerKm !="" && vehicleId!=null){
    const vehilcleDetail={
      "vehicle_id":vehicleId,
      "rate_per_km":ratePerKm,
      "commission_percentage": commissionPercentage
  }
  await rideService.updateRideRatePerKm(vehilcleDetail).then((res)=>{
    if(res.status==200){
      setIsSubmitted(true);
      window.location.reload();
    }
    else {
      setError("Something went wrong");
    }
  })
  }else{
    setError(" Field cannot be empty")
  }
   
  }
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
     
      <div className="bg-white p-6 rounded shadow-md">
        <h2 className="text-lg font-semibold mb-4">Update Rate Per Km</h2>
        {isSubmitted ? (
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4">
            Submitted successfully!
          </div>
        ) : null}
        {/* Input field to update the value */}
        <label> Rate Per KM</label>
        <br/>
        <input
          type="text"
          value={ratePerKm}
          onChange={handleInputChange}
          className="w-full border p-2 mb-4"
        />
        <br/>
        <label> Commission Percentage</label>
        <br/>
          <input
          type="number"
          value={commissionPercentage}
          onChange={handleCommissionChange}
          className="w-full border p-2 mb-4"
        />
     
        {error && <p className="text-red-500">{error}</p>}
        {/* Buttons for updating and canceling */}
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Update
          </button>
          <button
            onClick={onClose}
            className="ml-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePopup;